import { render, staticRenderFns } from "./DicRadioGroup.vue?vue&type=template&id=77f08f3f&scoped=true&"
import script from "./DicRadioGroup.vue?vue&type=script&lang=js&"
export * from "./DicRadioGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77f08f3f",
  null
  
)

export default component.exports